/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_New_Packages_HintInputs */

const en_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book your first session online. Your package is created automatically.`)
};

const es_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva tu primera sesión en línea; tu paquete se crea automáticamente.`)
};

const de_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen Sie Ihre erste Golfstunde online. Ihr Paket wird automatisch erstellt.`)
};

const zh_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线预订你的第一节课。课程套餐会自动创建。`)
};

const ar_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز جلستك الأولى عبر الإنترنت. تُنشأ باقتك تلقائياً.`)
};

const fr_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez votre première séance en ligne. Votre forfait est créé automatiquement.`)
};

const vi_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi đầu trực tuyến. Gói của bạn được tạo tự động.`)
};

const sw_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya kipindi chako cha kwanza mtandaoni. Kifurushi chako kinaundwa kiotomatiki.`)
};

const th_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองเซสชันแรกของคุณทางออนไลน์ แพ็คเกจของคุณถูกสร้างขึ้นโดยอัตโนมัติ`)
};

const bs_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite prvu sesiju online. Vaš paket se kreira automatski.`)
};

const ja_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のレッスンをオンラインでご予約ください。パッケージは自動的に作成されます。`)
};

const ko_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 세션을 온라인으로 예약하세요. 패키지는 자동으로 생성됩니다.`)
};

const pt_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende sua primeira sessão online. Seu pacote é criado automaticamente.`)
};

const it_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota la tua prima sessione online. Il pacchetto viene creato automaticamente.`)
};

const sv_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka din första session online. Ditt paket skapas automatiskt.`)
};

const nl_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek je eerste sessie online. Je pakket wordt automatisch aangemaakt.`)
};

const da_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestil din første session online. Din pakke oprettes automatisk.`)
};

const nb_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill din første økt online. Din pakke opprettes automatisk.`)
};

const fi_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa ensimmäinen tuntisi verkossa. Pakettisi luodaan automaattisesti.`)
};

const pl_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj pierwszą sesję online. Pakiet jest tworzony automatycznie.`)
};

const ru_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забронируйте первое занятие онлайн. Ваш пакет создаётся автоматически.`)
};

const tr_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk dersinizi online ayırtın. Paketiniz otomatik olarak oluşturulur.`)
};

const hi_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना पहला पाठ ऑनलाइन बुक करें। आपका पैकेज अपने-आप बन जाएगा।`)
};

const id_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan sesi pertama Anda secara online. Paket Anda dibuat secara otomatis.`)
};

const ms_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah sesi pertama anda dalam talian. Pakej anda dicipta secara automatik.`)
};

const cs_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervujte si první lekci online. Váš balíček se vytvoří automaticky.`)
};

const el_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε την πρώτη σας συνεδρία online. Το πακέτο σας δημιουργείται αυτόματα.`)
};

const he_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו את המפגש הראשון אונליין. החבילה נוצרת אוטומטית.`)
};

const af_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek jou eerste sessie aanlyn. Jou pakket word outomaties geskep.`)
};

const hu_booking_new_packages_hint = /** @type {(inputs: Booking_New_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglald le az első órádat online. A csomag automatikusan létrejön.`)
};

/**
* | output |
* | --- |
* | "Book your first session online. Your package is created automatically." |
*
* @param {Booking_New_Packages_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_new_packages_hint = /** @type {((inputs?: Booking_New_Packages_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_New_Packages_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_new_packages_hint(inputs)
	if (locale === "de") return de_booking_new_packages_hint(inputs)
	if (locale === "zh") return zh_booking_new_packages_hint(inputs)
	if (locale === "ar") return ar_booking_new_packages_hint(inputs)
	if (locale === "fr") return fr_booking_new_packages_hint(inputs)
	if (locale === "vi") return vi_booking_new_packages_hint(inputs)
	if (locale === "sw") return sw_booking_new_packages_hint(inputs)
	if (locale === "th") return th_booking_new_packages_hint(inputs)
	if (locale === "bs") return bs_booking_new_packages_hint(inputs)
	if (locale === "ja") return ja_booking_new_packages_hint(inputs)
	if (locale === "ko") return ko_booking_new_packages_hint(inputs)
	if (locale === "pt") return pt_booking_new_packages_hint(inputs)
	if (locale === "it") return it_booking_new_packages_hint(inputs)
	if (locale === "sv") return sv_booking_new_packages_hint(inputs)
	if (locale === "nl") return nl_booking_new_packages_hint(inputs)
	if (locale === "da") return da_booking_new_packages_hint(inputs)
	if (locale === "nb") return nb_booking_new_packages_hint(inputs)
	if (locale === "fi") return fi_booking_new_packages_hint(inputs)
	if (locale === "pl") return pl_booking_new_packages_hint(inputs)
	if (locale === "ru") return ru_booking_new_packages_hint(inputs)
	if (locale === "tr") return tr_booking_new_packages_hint(inputs)
	if (locale === "hi") return hi_booking_new_packages_hint(inputs)
	if (locale === "id") return id_booking_new_packages_hint(inputs)
	if (locale === "ms") return ms_booking_new_packages_hint(inputs)
	if (locale === "cs") return cs_booking_new_packages_hint(inputs)
	if (locale === "el") return el_booking_new_packages_hint(inputs)
	if (locale === "he") return he_booking_new_packages_hint(inputs)
	if (locale === "af") return af_booking_new_packages_hint(inputs)
	if (locale === "hu") return hu_booking_new_packages_hint(inputs)
	return en_booking_new_packages_hint(inputs)
});